/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import zoomDemo from 'shared/assets/virtual_sessions_assets/zoom-book-example.png';
import { WEB_CLIENT_URL } from 'shared/constants/index';

const useStyles = makeStyles(theme => ({
  divider: {
    width: '100%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  container: {
    paddingTop: theme.spacing(3),
    minHeight: '100vh',
    paddingBottom: theme.spacing(5),
  },
  mainTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  secondaryTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3),
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(1.2)',
  },
  zoomDemo: {
    maxWidth: '700px',
    width: '100%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

const ZoomDocumentation = () => {
  const classes = useStyles();
  const bullet = <span className={classes.bullet}>•</span>;
  return (
    <React.Fragment>
      <Container maxWidth="lg" className={classes.container}>
        <Typography variant="h3" className={classes.mainTitle}>
          Tutorfly Zoom Integration
        </Typography>

        <Typography variant="h4" className={classes.secondaryTitle}>
          Overview
        </Typography>

        <Typography variant="body1" gutterBottom>
          Tutorfly is a peer tutoring marketplace where students and parents of
          K-12 students can connect with qualified high school and
          university-aged tutors for effective and affordable 1:1 tutoring! You
          can connect your Zoom account to your Tutorfly account to host virtual
          lessons via your personal Zoom link!
        </Typography>

        <Typography variant="body1">
          Tutorfly shows an easy to enter button for all virtual sessions booked
          between clients and tutors on their respective Sessions dashboard. For
          each virtual lesson that you book on Tutorfly, you will have the
          option to hold the lesson with Tutorfly‘s Online Lessonspace or with
          your personal Zoom link. When Zoom is selected as the option to host
          the virtual lesson, the button shown on the session will open your
          personal Zoom link. With Tutorfly‘s Zoom integration, there is no more
          need to share your Zoom link with clients for each new session you
          create!
        </Typography>

        <Typography variant="h4" className={classes.secondaryTitle}>
          Prerequisite
        </Typography>

        <Typography variant="body1">
          {bullet}Free or Paid Zoom Account
        </Typography>
        <Typography variant="body1">{bullet}A Tutorfly Account</Typography>

        <Typography variant="h4" className={classes.secondaryTitle}>
          Installing the Zoom Integration
        </Typography>

        <Typography variant="body1">
          1.{' '}
          <a
            href={`${WEB_CLIENT_URL}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Login
          </a>{' '}
          to your Tutorfly account.
        </Typography>
        <Typography variant="body1">
          2. Navigate to your{' '}
          <a
            href={`${WEB_CLIENT_URL}/account-settings`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Account Settings
          </a>.
        </Typography>
        <Typography variant="body1">
          3. Click the <b>Connect Zoom</b> button on the <b>Account Settings</b>{' '}
          page.
        </Typography>
        <Typography variant="body1">
          4. Follow the steps on the Zoom Account Settings page to authorize
          Tutorfly to connect with your account.
        </Typography>

        <Typography variant="h4" className={classes.secondaryTitle}>
          Uninstalling the Zoom Integration
        </Typography>

        <Typography variant="body1">
          1. Login to your Zoom account and navigate to the{' '}
          <a
            href="https://marketplace.zoom.us/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Zoom marketplace
          </a>.
        </Typography>
        <Typography variant="body1">
          2. Click <b>Manage</b> {'>'} <b>Installed Apps</b>.
        </Typography>
        <Typography variant="body1">
          3. Click the <b>Tutorfly</b> app.
        </Typography>
        <Typography variant="body1">
          4. Click <b>Uninstall</b>.
        </Typography>

        <Typography variant="h4" className={classes.secondaryTitle}>
          Using the Tutorfly Zoom Integration
        </Typography>

        <Typography gutterBottom variant="body1">
          When booking tutoring sessions, you will have the option to select
          your own Zoom conferencing room instead of Tutorfly’s Lessonspace as
          seen in the picture below.
        </Typography>

        <Typography variant="body1" gutterBottom>
          When you are booking your sessions, make sure to select the{' '}
          <b>
            <u>Zoom</u>
          </b>{' '}
          option. When your session shows up on your and your tutee/tutor‘s
          Sessions dashboard, the{' '}
          <b>
            <u>Join Zoom</u>
          </b>{' '}
          button will open your Zoom room.
        </Typography>

        <img src={zoomDemo} className={classes.zoomDemo} />

        <Typography variant="h4" className={classes.secondaryTitle}>
          Contact Support
        </Typography>

        <Typography gutterBottom variant="body1">
          If you have any issues integrating your Zoom account with your
          Tutorfly account or booking sessions with Zoom, please feel free to
          email our team at info@tutorfly.org.
        </Typography>

        <Typography gutterBottom variant="body1">
          We ensure that you will have a response from a Tutorfly team member
          within a maximum of 72 hours.
        </Typography>
      </Container>
    </React.Fragment>
  );
};

export default ZoomDocumentation;
